import type { FieldProps } from './TextField';
import { useFormField } from '../../hooks/useFormField';

export function MessageField({ fieldSchema, group }: FieldProps) {
  const field = useFormField(fieldSchema, group);

  if (!field.show) {
    return null;
  }

  return (
    <div>
      <hr className="pull-right" />
      <div className="stepform-question-wrapper" id={`field-${field.question.id}`}>
        <div dangerouslySetInnerHTML={{ __html: fieldSchema.text || '' }} />
      </div>
    </div>
  );
}
